import {
  FIT_TYPE,
  SPEND_SCALE,
  fitCurve,
  parameterCount,
  residualSampleStd,
} from './fitCurve';

export const MIN_TRAIN = 3;

function trainingPoints(cohorts) {
  return cohorts
    .filter((cohort) => cohort.uaSpend > 0 && cohort.cac > 0)
    .map((cohort) => ({
      x: cohort.uaSpend / SPEND_SCALE,
      y: cohort.cac,
    }));
}

export function visibleCohortForecasts(cohorts, selectedIds) {
  const selected = new Set(selectedIds || []);
  return forecastCohortCac(cohorts).filter(
    (cohort) => selected.has(cohort.id) && cohort.uaSpend > 0 && cohort.forecastCac > 0
  );
}

export function forecastCohortCac(cohorts) {
  return (cohorts || []).map((cohort, index) => {
    const training = trainingPoints(cohorts.slice(0, index));
    if (training.length < MIN_TRAIN || !(cohort.uaSpend > 0)) {
      return { ...cohort, forecastCac: null };
    }

    const fit = fitCurve(FIT_TYPE.LINEAR, training);
    const forecastCac = fit ? fit.evaluate(cohort.uaSpend / SPEND_SCALE) : null;
    return {
      ...cohort,
      forecastCac:
        forecastCac != null && Number.isFinite(forecastCac) && forecastCac > 0
          ? forecastCac
          : null,
    };
  });
}

export function fitForecastOverlay(cohorts, fitType) {
  const points = (cohorts || [])
    .filter((cohort) => cohort.forecastCac > 0 && cohort.uaSpend > 0)
    .map((cohort) => ({
      x: cohort.uaSpend / SPEND_SCALE,
      y: cohort.forecastCac,
    }));
  const minimumPoints = Math.max(MIN_TRAIN, parameterCount(fitType) + 1);
  if (points.length < minimumPoints) {
    return null;
  }

  const fit = fitCurve(fitType, points);
  if (!fit) {
    return null;
  }

  return {
    fit,
    sigma: residualSampleStd(points, fit.evaluate),
    points,
  };
}
